import { ClientEnvironment, ClientEnvironmentName } from '../modules/core/types/environment';

export const environment: ClientEnvironment = {
	environmentName: ClientEnvironmentName.DEV,
	apiUrl: 'https://api.dev.rea.ch',
	clientUrl: 'https://mobile.dev.rea.ch',
};
